// DS: PO32
import React, { useEffect } from 'react';
import VideoPopup from '@wix/da-shared-react/pkg/Popup/DeviationVideo';
import { useBiLogger } from '@wix/da-shared-react/pkg/biLogger/hooks/useBiLogger';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger/constants';

export interface Props {
  className?: string;
  onClose(): void;
}

const source =
  '//film00.deviantart.net/5362/v/mp4/2019/135/7/9/da_customizingprofile_offline2_by_team-dd6ycfy.mp4';

const ProfileHeroIntroPopup: React.FC<Props> = ({ onClose }) => {
  const logEvent = useBiLogger();

  useEffect(() => {
    logEvent({
      evid: BiEventType.PROFILE_WATCH_INTRO,
      link_url: source,
      itemid: undefined,
      typeid: undefined,
    });
  }, [logEvent]);

  return (
    <VideoPopup
      deviationId={797740414}
      onRequestClose={onClose}
      posterFrame="//st.deviantart.net/eclipse/popups/welcome/da_customizingprofile_offline2_by_team-dd6ycfy.png"
      autoPlay={true}
    />
  );
};

ProfileHeroIntroPopup.displayName = 'ProfileHeroIntroPopup';
export default ProfileHeroIntroPopup;
